import { sdkRequest } from '@eventbrite/http';
import { INITIAL_QUERY } from '../context/search';
import {
    EXPANSIONS,
    OrganicEventSearchApiPayload,
    OrganicEventSearchApiResponse,
    OrganicEventSearchFiltersApiPayload,
} from './types';

export type EventsQueryKey = [
    'POI' | 'TTD' | 'search',
    'events',
    string | 'tag',
    string | 'location',
    string,
];

export const getQueryKey = (
    eventSearch: OrganicEventSearchFiltersApiPayload,
): EventsQueryKey => {
    const normalizedEventSearch: OrganicEventSearchFiltersApiPayload = {
        ...INITIAL_QUERY,
        ...eventSearch,
        dates:
            typeof eventSearch.dates === 'string'
                ? [eventSearch.dates]
                : eventSearch.dates,
    };

    const locationTag = normalizedEventSearch.online_events_only
        ? 'online'
        : eventSearch?.places?.[0] || 'location';
    const activeTag = normalizedEventSearch?.tags?.at(0) || 'tag';
    const page_type = eventSearch.page_type || 'search';

    const date = normalizedEventSearch?.dates?.at(0) || 'default';

    return [page_type, 'events', activeTag, locationTag, date];
};

/*
    Search Functionality
*/

export function searchOrganicEvents(
    search: OrganicEventSearchApiPayload,
): Promise<OrganicEventSearchApiResponse> {
    return sdkRequest('/api/v3/destination/search/', {
        method: 'POST',
        body: JSON.stringify(search),
    });
}

export const search = (
    eventSearch: OrganicEventSearchFiltersApiPayload,
    expansions = EXPANSIONS,
): Promise<OrganicEventSearchApiResponse> => {
    const { page_type, ...search_data } = eventSearch;

    const filters: OrganicEventSearchApiPayload = {
        browse_surface: page_type || 'search',
        event_search: search_data,
        ...expansions,
    };

    return searchOrganicEvents(filters);
};
